module.exports = __webpack_public_path__ + "img/quality_icon_green.950bf96e.svg";